import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-title" }
const _hoisted_4 = { class: "panel-label" }
const _hoisted_5 = { class: "panel-count" }

import type { User } from "@/types/user";
import type { ColumnKey } from "@/components/user/UserTable.vue";
import UserTable from "@/components/user/UserTable.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardPanel',
  props: {
    title: {},
    users: {},
    dot: {},
    columns: { default: () => ["id", "username", "fullName"] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(['panel-dot', `panel-dot--${__props.dot}`])
        }, null, 2),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.users.length), 1)
    ]),
    _createVNode(UserTable, {
      users: __props.users,
      columns: __props.columns
    }, null, 8, ["users", "columns"])
  ]))
}
}

})